<template>
  <section class="scn" :class="color ? `scn--${color}` : undefined">
    <slot />
    <div v-observe-visibility="checkCurrentSectionScroll" class="scn-name-emitter" />
  </section>
</template>
<script>
export default {
  name: 'Scn',
  props: {
    color: String
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    checkCurrentSectionScroll (isCurrentSectionOnTop, { target }) {
      const sectionName = target.parentNode.getAttribute('data-name')
      if (isCurrentSectionOnTop) {
        this.$root.$emit('current-section-change', sectionName)
      }
    },
    collectAccordions () {
      const accordions = this.$children.filter(child => child.$el.className.includes('accordion'))
      if (accordions.length) this.$store.dispatch('saveAccordions', accordions)
    }
  },
  watch: {
    currentLocale () {
      this.$nextTick(() => { this.collectAccordions() })
    },
    deep: true
  },
  mounted () {
    this.$root.$on('update-accordions-list', () => {
      this.$nextTick(() => { this.collectAccordions() })
    })
    this.$nextTick(() => { this.collectAccordions() })
  }
}
</script>
<style scoped lang="sass">
@tailwind utilities

.scn-name-emitter
  @apply absolute z-50 pin-l w-px h-px
  top: 100vh
</style>
